module.exports = __webpack_public_path__ + "assets/images/boundaries/keys-three-smc/key-2-2020.svg?v=02352e63";